import React from "react";
import { CLASS_GOLD, CLASS_IMAX, CLASS_PREMIUM, CLASS_PREMIUM_PLUS } from "@config/config";
import VoucherTitle from "@components/VoucherManager/VoucherTitle/index.js";
import getCinemaGroupLogo from "@utils/getCinemaGroupLogo";
import "./style.scss";

const VoucherLogo = ({ item }) => {
    const { tile_class, intro, ticket_class, cinema_group_id, voucher_image_url } = item;
    const CinemaGroupLogo = getCinemaGroupLogo(cinema_group_id);

    const logoFillColor =
        ticket_class === CLASS_GOLD
            ? "gold"
            : ticket_class === CLASS_PREMIUM || ticket_class === CLASS_PREMIUM_PLUS || ticket_class === CLASS_IMAX
                ? "black"
                : "white";

    return (
        <>
            {voucher_image_url ? (
                <div className="voucher__logo-wrapper">
                    <img src={voucher_image_url} alt={voucher_image_url} className="voucher__logo-image" />
                </div>
            ): (
                <div className={`voucher__tile voucher__tile--${tile_class}`}>
                    <div className="voucher__logo">
                        <CinemaGroupLogo fillColour={logoFillColor} />
                    </div>
                    <VoucherTitle
                        intro={intro}
                        consumableDescription={item.description}
                    />
                </div>
            )}
        </>
    );
};

export default VoucherLogo;
